<template>
  <div class="level-icon">
    <svg
      style="width: 20px; height: 20px"
      viewBox="0 0 22 22"
      v-if="level.value === '1'"
    >
      <path
        fill="currentColor"
        d="M19.5,5.5V18.5H17.5V5.5H19.5M12.5,10.5V18.5H10.5V10.5H12.5M21,4H16V20H21V4M14,9H9V20H14V9M7,14H2V20H7V14Z"
      />
    </svg>
    <svg
      style="width: 20px; height: 20px"
      viewBox="0 0 22 22"
      v-if="level.value === '2'"
    >
      <path
        fill="currentColor"
        d="M19.5,5.5V18.5H17.5V5.5H19.5M21,4H16V20H21V4M14,9H9V20H14V9M7,14H2V20H7V14Z"
      />
    </svg>
    <svg
      style="width: 20px; height: 20px"
      viewBox="0 0 22 22"
      v-if="level.value === '3'"
    >
      <path
        fill="currentColor"
        d="M21,4H16V20H21V4M14,9H9V20H14V9M7,14H2V20H7V14Z"
      />
    </svg>
    <span>{{ level.label }}</span>
  </div>
</template>

<script>
export default {
  props: {
    level: Object,
  },
};
</script>


<style lang="scss">
.video-item {
  .video-info {
    .level-icon {
      svg {
        top: 4px;
        transform: rotateY(180deg);
      }
    }
  }
}
</style>
  
